import PopoverFooter from "@molecules/Popover/PopoverFooter/PopoverFooter"

export default PopoverFooter
